import React from "react";
import classes from "./style.module.css";
import NewImg from "../../../../assets/images/joftPooch/new.png";

export default function MatchMenuElement({
  elementInfo,
  fullWidth,
  handleClick,
  disable,
  showNew,
}) {
  let containerClasses = [classes.menuElement];
  if (!fullWidth) {
    containerClasses.push(classes.smallElement);
  }
  if (disable) {
    containerClasses.push(classes.disabled);
  }

  return (
    <div onClick={handleClick} className={containerClasses.join(" ")}>
      {showNew && (
        <img src={NewImg} className={classes.newImg} alt="new-badge" />
      )}
      <img src={elementInfo.icon} alt={elementInfo.text} />
      <p>{elementInfo.text}</p>
    </div>
  );
}
